

import { useCallback } from "react";
import { toast } from "react-toastify";
import { useRazorpay } from "react-razorpay";
import { pay_gioo_plot } from "../api/Payment";
import { get_settings } from "../api/ControllApi";

export function usePayment() {
    const handlePayment = useCallback(
        async (totalPayableAmount, property_id, units, payloadExtras = {}) => {
            return new Promise(async (resolve, reject) => {
                const loadRazorpay = () => {
                    return new Promise((res) => {
                        if (window.Razorpay) return res(window.Razorpay);
                        const script = document.createElement("script");
                        script.src = "https://checkout.razorpay.com/v1/checkout.js";
                        script.onload = () => res(window.Razorpay);
                        script.onerror = () => res(null);
                        document.body.appendChild(script);
                    });
                };

                const Razorpay = await loadRazorpay();
                if (!Razorpay) return reject("Razorpay not loaded");

                let razorpayKey = process.env.REACT_APP_RAZOR_PAY;
                try {
                    const settingsRes = await get_settings();
                    if (settingsRes?.data?.payment_api_key) {
                        razorpayKey = settingsRes.data.payment_api_key;
                    }
                } catch (err) {
                    console.error("Failed to load dynamic payment_api_key:", err);
                }

                const options = {
                    key: razorpayKey,
                    amount: totalPayableAmount * 100,
                    currency: "INR",
                    name: "Cashback Farms",
                    description: "Voucher Payment",
                    image: "/assets/icons/__Fav Icon.png",
                    handler: async function (res) {
                        const transactionId = res.razorpay_payment_id;
                        const payLoad = {
                            status: "success",
                            payment_id: transactionId,
                            transaction_details: "test",
                            amount: totalPayableAmount,
                            property_id,
                            units,
                            ...payloadExtras
                        };
                        try {
                            const result = await pay_gioo_plot(payLoad);
                           toast.success(result?.data?.message || "Payment successful!");
                            resolve(result);
                        } catch (err) {
                            toast.error("Something went wrong!");
                            reject(err);
                        }
                    },
                    theme: { color: "#C7DD94" },
                };

                const rzpay = new Razorpay(options);
                rzpay.open();

                rzpay.on("payment.failed", (response) => {
                    toast.error(response.error.description || "Payment failed");
                    reject(response.error);
                });
            });
        },
        []
    );
    return { handlePayment };
}
